import * as React from "react";
import styled from "styled-components";
import Assets from "../../../assets/img/assets";

interface IProps {
  count: number;
  withIcon: boolean;
}

const UnReadCount: React.FC<IProps> = (props) => {
  if (props.count === 0) {
    return <div />;
  }

  return (
    <Budge>
      <span>{props.count > 99 ? "99+" : `${props.count}`}</span>
      {props.withIcon && <img src={Assets.bell} />}
    </Budge>
  );
};

export default UnReadCount;

const Budge = styled.div`
  display: inline-block;
  position: relative;
  width: 35px;
  height: 25px;
  margin-left: 10px;

  & span {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    padding: 2px 0px;
    width: 30px;
    text-align: center;
    border: solid 2px #ffffff;
    background-color: #9a8c64;
    color: #ffffff;
    font-weight: 900;
    font-size: 8px;
    border-radius: 30px;
    z-index: 2;
  }

  & img {
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 14px;
    z-index: 1;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/menu/unread_count.tsx